<form [formGroup]="form">
  <div>
    <!-- tag / team / lang -->
    <mat-form-field>
      <mat-label translate="triage_config/actions/tag_choose_tag"></mat-label>
      <mat-select formControlName="tagGroupId" (selectionChange)="onGroupChange()" data-testid="select-group">
        <mat-option *ngFor="let group of items" [value]="group.id">{{ group.label }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="selectedGroup">
    <ng-container formArrayName="tagIdsAndPercentagesFormArray">
      <div *ngFor="let tagIdsAndPercentage of tagIdsAndPercentagesFormArray.controls; let i = index" class="field">
        <ng-container [formGroupName]="i">
          <div>
            <span class="alc-space-after" translate="triage_config/actions/random-dispatch/either"></span>
          </div>

          <!-- sub item -->
          <div>
            <mat-form-field>
              <mat-label translate="triage_config/actions/tag_choose_value"></mat-label>
              <mat-select formControlName="tagId" [attr.data-testid]="'select-sub-item-' + i">
                <mat-optgroup *ngFor="let item of selectedGroup.items" [label]="item.label">
                  <mat-option *ngFor="let subitem of item.subitems" [value]="subitem.id">
                    {{ subitem.label }}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </div>

          <div>
            <span class="alc-space-before alc-space-after" translate="triage_config/actions/random-dispatch/at"></span>
          </div>

          <!-- percentage -->
          <div>
            <mat-form-field>
              <mat-label translate="triage_config/actions/tag_1st_message_choose_percent"></mat-label>
              <mat-select
                (selectionChange)="onPercentageChange(i)"
                formControlName="percentage"
                [attr.data-testid]="'select-percentage-' + i">
                <mat-option *ngFor="let item of percentageItems" [value]="item.id">{{ item.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- button remove -->
          <div>
            <button
              *ngIf="i >= 2"
              mat-icon-button
              type="button"
              (click)="removeSubItem(i)"
              [attr.data-testid]="'button-remove-' + i">
              <mat-icon class="error">delete</mat-icon>
            </button>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <mat-error
      *ngIf="form.errors?.percentagesSum"
      [translate]="'triage_config/actions/random-dispatch/error-sum-percentages'"
      [translateParams]="{ percentage: totalPercentageForError }"
      data-testid="percentage-error"></mat-error>

    <button
      mat-stroked-button
      type="button"
      color="primary"
      *ngIf="isTypeRandomDispatch && tagIdsAndPercentagesFormArray.value.length < 20"
      (click)="addSubItem()"
      data-testid="button-add">
      <span translate="add"></span>
    </button>
  </div>
</form>
